import { z } from 'zod';

import { UserStatus } from 'src/api';

import { accessValidationShape } from '../../../ClearVerifyStaffAccessFormPart/validation';

import { FormFields } from './constants';
import { FormValues } from './types';

export const formValidationSchema = z.object({
  [FormFields.status]: z.enum(UserStatus),
  ...accessValidationShape,
}) satisfies z.ZodType<FormValues>;
